<template lang="html">
    <div class="detail-tab-view">
        <div class="sticky-tabs" v-sticky="{zIndex: 5, stickyTop: -1}">
            <ul class="head-tab" ref="headTab">
                <li v-for="(item, index) in tabList" :class="{active: index == tabIndex}" @click="showSection(item, index)">{{item.desc}}</li>
            </ul>
        </div>
        <div class="tab-content" v-for="(item, index) in tabList" :ref="'tab-content-' + index">
            <product-detail v-if="item.name === 'productDetail'" :detailData="detailData"></product-detail>
            <journey v-if="item.name === 'journey'" :isSummary="true" :journeyData="journeyData"></journey>
            <purchase-notes v-if="item.name === 'purchaseNotes'" :prdTmpId="prdTmpId" :purchaseNotes="purchaseNotes" :packageData="packageData" :detailData="detailData" :reserveNotice="reserveNotice" :backRule="backRule"></purchase-notes>
            <recommend v-if="item.name === 'businessmenRecommend'" :crossRecommend="crossRecommend" ></recommend>
            <comment v-if="item.name === 'comment'" :showComment="showComment"></comment>            
        </div>
    </div>
</template>
<script type="text/javascript">
import {sortBy} from 'lodash';
import TouchStrip from '@/components/TouchStrip';
import Popup from '@/components/Popup';
import Sticky from '@/components/sticky';
import ProductDetail from '@/components/detail/tabView/ProductDetail';
import Journey from '@/components/detail/tabView/Journey';
import purchaseNotes from '@/components/detail/tabView/PurchaseNotes';
import Recommend from '@/components/detail/tabView/Recommend';
import Comment from '@/components/detail/Comment';
import {eventTrack} from '@/business/analy';
import detailStoreModule from '@/store/modules/detail';
const TOPBAR_OFFSET = 48;

export default {
    props: {
        tabList: {
            type: Array,
            default: function () {
                return []
            }
        },
        detailData: {
            type: Object,
            default: function () {
                return {}
            }
        },
        crossRecommend: {
        	type: Array,
            default: function () {
                return {}
            }
        },
        packageData: {
            type: Object,
            default: function () {
                return {}
            }
        },
        journeyData: {
            type: Array,
            default: function () {
                return []
            }
        },
        purchaseNotes: {
        	type: Object,
            default: function () {
                return []
            }
        },
        reserveNotice: {
            type: String,
            default: function () {
                return ''
            }
        },
        backRule: {
            type: String,
            default: function () {
                return ''
            }
        },
        prdTmpId: {
            type: Number,
            default: function () {
                return 5
            }
        },
        isApp: {
            type: Boolean,
            default: function () {
                return false
            }
        }
    },
    data: function () {
        return {
            tabIndex: 0,
            headTabStyle: '',
            headerHeight: 0,
            showComment: false
        }
    },
    created () {
    },
    mounted: function () {
        window.addEventListener('scroll', this.updateState, false);
    },
    beforeDestroy: function() {
        window.removeEventListener('scroll', this.updateState, false);
    },
    directives: {
        'sticky': Sticky
    },
    computed: {
    },
    methods: {
        showSection (item, index) {
        	document.body.scrollTop = document.documentElement.scrollTop = this.$refs['tab-content-' + index][0].offsetTop - TOPBAR_OFFSET;
            this.tabIndex = index;          
            if (item.name === 'comment') {
                this.showComment = true;
                eventTrack('CLICK_INDEX_COMMENT');
            }
        },
        openPolicy: function () {
            this.$router.push(this.$route.path + '/policy');
            eventTrack('CLICK_INDEX_POLICY');
        },
        openNotice: function () {
            this.$router.push(this.$route.path + '/notice');
            eventTrack('CLICK_INDEX_NOTICE');
        },
        updateState () {
            clearTimeout(updateTimer);
            let updateTimer = setTimeout(this.onScroll, 100);
        },
        onScroll: function () {
            if (~document.body.className.indexOf('pageFixed')) {
                return;
            }
            let sTop = (document.documentElement.scrollTop || document.body.scrollTop) + TOPBAR_OFFSET + 0.1;
            let offsetTopList = this.tabList.map((e, i) => (this.$refs['tab-content-' + i][0] && this.$refs['tab-content-' + i][0].offsetTop) || 9999);
            let indexInArray = sortBy(offsetTopList.concat(sTop), (item) => item).indexOf(sTop);
            this.tabIndex = indexInArray > 1 ? (indexInArray - 1) : 0;
            if((document.documentElement.scrollTop || document.body.scrollTop)>=(document.documentElement.scrollHeight || document.body.scrollHeight)-(document.documentElement.clientHeight || document.body.clientHeight)){
            	this.tabIndex=this.tabList.length-1;
            }
            let commentIndex = this.tabList.findIndex(e => e.name === 'comment');
            if (!this.showComment){
                let commentIndex = this.tabList.findIndex(e => e.name === 'comment');
                if (commentIndex && indexInArray) {
                    this.showComment = true;
                }
            }
        },
        eventTrack
    },
    filters: {
        nr2br: function(value) {
            if (value) {
                return String(value).replace(/([\\\n\n\\\r\r]+)/g, '</br>');
            }
            return value
        }
    },
    components: {
        TouchStrip,
        Popup,
        ProductDetail,
        Journey,
        purchaseNotes,
        Recommend,
        Comment
    }
}
</script>
<style lang="scss">
@import '../../style/common.scss';

.detail-tab-view {
    background: #fff;
    padding-bottom: 20px;
    border-radius: $borderBigRadius;
    .box-for-tab {
        height: 58px;
    }
    .sticky {
        div {
            display: none;
        }
    }
    .sticky-tabs {
        box-sizing: border-box;
        width: 100%;
        background: #fff;
        overflow: hidden;
        border-top-left-radius: $borderBigRadius;
        border-top-right-radius: $borderBigRadius;
    }
    .head-tab{
        display: flex;
        width: 100%;
        height:48px;
        background: #fff;
        z-index: 2;
        box-sizing: border-box;
        &:after {
            content: '';
            position: absolute;
            bottom: 0;
            left: 18px;
            right: 18px;
            height: 1px;
            z-index: 1;
            background: linear-gradient(bottom, rgba(0, 0, 0, 0.05), transparent 50%, transparent);
        }
        li {
            flex: 1;
            width: 0;
            height: 100%;
            text-align: center;
            line-height: 48px;
            font-size: 14px;
            color: $fontStrongColor;
            opacity: 0.75;
            touch-action: manipulation;
        }
        .active {
            position: relative;
            font-size: 16px;
            opacity: 1;
            font-weight: 600;
            &:after {
                content: "";
                position: absolute;
                bottom: 0;
                left: 50%;
                z-index: 2;
                transform: translateX(-50%);
                width: 64px;
                height: 3px;
                background: $greenColor;
            }
        }
    }
    .top {
        margin-top: 0;
        position: fixed;
        top: 0;
    }
    .tab-content:not(first-child){
        margin-bottom: 9px;
        padding: 0 18px;
    }
}
</style>



// WEBPACK FOOTER //
// Index.vue